import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { Typography } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { selectRecruiter } from 'actions/map';
import strings from 'strings';
import { When } from 'UI/components/atoms';
/** Material Assets and Components */
/** Atoms, Components and Styles */
import Text from 'UI/components/atoms/Text';
import { MapEntityInfo } from 'UI/components/molecules/MapEntityInfo';
import { getTeamsSpecialtyDetails } from 'UI/components/molecules/MapEntityInfo/MapEntityInfo.utils';
import SideFiltersLayoutConnected from 'UI/components/templates/SideFiltersLayout';
import { SearchResultsNotFound } from 'UI/res';

import { FiltersGroups } from './columns';
import { useStyles } from './styles';
import { transformPilListData } from './utils';

const UserCardContainer = props => {
  const { recruiters } = props;

  const dispatch = useDispatch();

  const handleClick = info => dispatch(selectRecruiter(info));

  return (
    <>
      {recruiters.map(item => {
        const { details, detailsLabel } = getTeamsSpecialtyDetails(item.teams);
        const coach = item.coach || item.teams?.[0]?.coach || '';

        return (
          <li key={item.recruiter_id}>
            <ListItem button onClick={() => handleClick(item)} divider>
              <MapEntityInfo
                details={details}
                detailsLabel={detailsLabel}
                entitySubtitle={
                  coach ? strings.formatString(strings.map.dig.recruiterInfo.team, { coach }) : ''
                }
                entityTitle={item.full_name}
              />
            </ListItem>
          </li>
        );
      })}
    </>
  );
};

/**
 * @param {Object} props
 * @param {Array<Object>} props.recruiters
 * @param {boolean} props.hasLoaded
 * @param {number} props.itemsCount
 */
const MapDigTab = ({ recruiters, hasLoaded, itemsCount }) => {
  const classes = useStyles();
  const hasResults = itemsCount > 0;
  return (
    <SideFiltersLayoutConnected
      enableCollapsibleForm
      section="dig"
      groups={FiltersGroups}
      defaultFilters={{}}
      resultsFound={hasResults}
      showGoToTop={itemsCount > 10}
      emptyContent={
        hasLoaded &&
        !itemsCount && (
          <div className={classes.noResultsContainer}>
            <Text text={strings.map.dig.noResults.title} className={classes.noResultsBoldTxt} />
            <Text
              text={strings.map.dig.noResults.subtitle}
              className={classes.noResultsSubtitleTxt}
            />
            <SearchResultsNotFound width={150} height={185} />
          </div>
        )
      }
    >
      <When condition={hasResults}>
        <Typography variant="body2" className={classes.resultsContainer}>
          Showing <strong>{recruiters.length} </strong>
          results
        </Typography>
        <List>
          <UserCardContainer recruiters={recruiters} />
        </List>
      </When>
    </SideFiltersLayoutConnected>
  );
};

const mapStateToProps = ({ map }) => ({
  recruiters: transformPilListData(map.domain.recruiters),
  itemsCount: map.domain.recruiters ? map.domain.recruiters.length : 0,
  list: map.domain.recruiters,
  isLoading: map.ui.isLoading,
  hasLoaded: map.ui.hasLoaded
});

const MapDigTabConnected = connect(mapStateToProps, null)(MapDigTab);

export default MapDigTabConnected;
